
















































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { getVoteList, getDetail } from '@/api/project';
import { askVote } from '@/api/projectVote';
import moment from 'moment';
import { hasPermission } from '@/utils/utils';
import MeetingVoteEdit from '@/components/meeting/meetingDetail/meetingVoteEdit.vue';
import { mapGetters } from 'vuex';
import { getICList } from '@/api/common.js';

@Component({
  components: {
    MeetingVoteEdit
  },
  computed: { ...mapGetters(['userInfo']) }
})
class vote extends Vue {
  @Prop()
  visible; // round

  @Prop()
  projectId;

  oInfo: any = {};
  userInfo: any;
  voteList: Array<object> = [];
  isNewVote: boolean = false;
  moment: object = moment;
  scoreMap: object = {
    '1': '正面',
    '0.5': '偏正面',
    '0': '弃权',
    '-0.5': '偏负面',
    '-1': '负面'
  };
  colorMap: object = {
    '1': '#73D13D',
    '0.5': '#81D3F8',
    '0': '#7f7f7f',
    '-0.5': '#F59A23',
    '-1': '#F5222D'
  };
  // visible: boolean = false;
  modalVisible: boolean = false;
  confirmLoading: boolean = false;
  hasVotePermission: boolean = false;
  showVotes: boolean = false;
  ICList: Array<object> = [];

  @Watch('projectId', { immediate: true })
  projectIdChange() {
    this.getICList();
    this.getCompanyDetail();
    this.getVoteList();
  }

  fail(msg) {
    this.confirmLoading = false;
  }
  async getICList() {
    try {
      let res = await getICList();
      if (res.code === 200) {
        this.ICList = res.data;
      }
    } catch (err) {
      console.log(err);
    }
  }

  async refresh() {
    this.modalVisible = false;
    this.confirmLoading = false;
    this.getVoteList();
  }

  async created() {
    const { permissions: queue } = this.userInfo || {};
    this.hasVotePermission = hasPermission(queue, '/meeting/detail/addVote');
  }

  async getCompanyDetail() {
    try {
      let res = await getDetail(this.projectId);
      if (res.code === 200) {
        this.showVotes = res.data.showVotes;
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }

  async getVoteList() {
    try {
      let res = await getVoteList({ companyId: this.projectId });
      this.voteList = res.data;
    } catch (e) {
      this.$message.error(e);
    }
  }

  showModal(type, item = null) {
    this.isNewVote = type === 'new' ? true : false;
    this.oInfo = item;
    this.modalVisible = true;
  }

  handleOk() {
    this.confirmLoading = true;
    //@ts-ignore
    this.$refs.edit.submit();
  }

  handleCancel() {
    this.oInfo = null;
    this.modalVisible = false;
  }

  afterVisibleChange(val) {
    this.$emit('update:visible', val);
  }

  onClose() {
    this.$emit('update:visible', false);
  }

  openUrl() {
    window.open(this.voteList[0]['exportDocUrl'], '_blank');
  }
}

export default vote;
